import { type ReactNode, type RefObject, useRef, useState } from 'react';

import { PortalContainerContext } from '@spotify-internal/encore-web';
import { Popover } from '@spotify-internal/encore-web/next';

type FilterEditorPopoverProps = {
  children: ReactNode;
  label: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  trigger: (triggerRef: RefObject<HTMLElement>) => ReactNode;
};

export const FilterEditorPopover = ({
  children,
  label,
  isOpen,
  onOpenChange,
  trigger,
}: FilterEditorPopoverProps) => {
  const triggerRef = useRef<HTMLElement>(null);
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(
    null,
  );

  return (
    <>
      {trigger(triggerRef)}
      <Popover
        ref={setPortalContainer}
        aria-label={label}
        hasNoArrow
        isOpen={isOpen}
        placement="bottomStart"
        triggerRef={triggerRef}
        width="max-content"
        onOpenChange={onOpenChange}
      >
        <PortalContainerContext.Provider value={portalContainer ?? undefined}>
          {children}
        </PortalContainerContext.Provider>
      </Popover>
    </>
  );
};
